import BaseWrapper from "../../components/BaseWrapper/BaseWrapper"
import Content from "./Content"

const Settings = () => <BaseWrapper content={<Content showApplicationSettings />}/>

export default Settings
